import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import dayjs from 'dayjs'

import { actions } from 'redux/slice/app'
import { selectIsNoticePopupDismissed, selectEnableIDCardPopup, selectIsMemberAnnounceLoaded } from 'redux/selector/app'
import { IDCARD_POPUP_DISMISSED_DATE_KEY } from 'constant/common'

import IDCard from 'page/SystemConfig/component/IDCard'

import { Overlay, Content, Footer, CheckboxLabel, CloseButton } from './Styled'

const today = () => dayjs().format('YYYY-MM-DD')

const isDismissedToday = () => {
  return localStorage.getItem(IDCARD_POPUP_DISMISSED_DATE_KEY) === today()
}

export default function IDCardPopup() {
  const dispatch = useDispatch()
  const isLoaded = useSelector(selectIsMemberAnnounceLoaded)
  const isNoticePopupDismissed = useSelector(selectIsNoticePopupDismissed)
  const enableIDCardPopup = useSelector(selectEnableIDCardPopup)
  const [dontRemind, setDontRemind] = useState(false)
  const [visible, setVisible] = useState(() => !isDismissedToday())

  const shouldShow = isLoaded && isNoticePopupDismissed && enableIDCardPopup && visible

  useEffect(() => {
    if (isLoaded && isNoticePopupDismissed && !shouldShow) {
      dispatch(actions.dismissIDCardPopup())
    }
  }, [isLoaded, isNoticePopupDismissed, shouldShow, dispatch])

  if (!shouldShow) return null

  const handleClose = () => {
    if (dontRemind) {
      localStorage.setItem(IDCARD_POPUP_DISMISSED_DATE_KEY, today())
    }
    setVisible(false)
  }

  return (
    <Overlay onClick={handleClose}>
      <Content onClick={(e) => e.stopPropagation()}>
        <IDCard onClose={handleClose} />
      </Content>
      <Footer onClick={(e) => e.stopPropagation()}>
        <CheckboxLabel>
          <input
            type="checkbox"
            checked={dontRemind}
            onChange={(e) => setDontRemind(e.target.checked)}
            data-testid="idcard_popup_dont_remind"
            aria-label="idcard_popup_dont_remind"
          />
          本日不再提醒
        </CheckboxLabel>
        <CloseButton
          onClick={handleClose}
          data-testid="idcard_popup_close"
          aria-label="idcard_popup_close"
        >
          ✕
        </CloseButton>
      </Footer>
    </Overlay>
  )
}
